'use strict';

import angular from 'angular';

export default angular.module('translate', [])
  .provider('translationLoader', [
    function () {
      this.$get = [
        '$q',
        '$rootScope',
        'translations',

        function ($q, $rootScope, translations) {
          var service = function () {
            var deferred = $q.defer();

            deferred.resolve(translations);
            return deferred.promise;
          };

          /**
           * Extends `translations` service.
           * @param {Object} partial
           */
          service.addTranslationPartial = function (partial) {
            angular.extend(translations, partial);
            $rootScope.$emit('translationLoader:refresh');
          };

          return service;
        }
      ];
    }
  ])
  .value('translations', {})
  .name;



// WEBPACK FOOTER //
// ./app/src/translate.js